// externals
import type { FC } from 'react';

// libraries
import { ArrowUturnLeftIcon, TrashIcon } from '@interstate/components/Icons';
import { Button } from '@interstate/components/Button';

// styles
import { AccessoryActionBaseIconContainer } from '../../ManualAccessories.interstate.styles';

export type ManualAccessoryActionIconProps = {
    deleted: boolean;
    index: number;
    restoreAccessory: (index: number) => void;
    removeAccessory: (index: number) => void;
    disabled?: boolean;
};
export const ManualAccessoryActionIcon: FC<ManualAccessoryActionIconProps> = ({
    deleted,
    index,
    restoreAccessory,
    removeAccessory,
    disabled = false
}) => {
    return (
        <AccessoryActionBaseIconContainer>
            {deleted ? (
                <Button
                    buttonStyle={'tertiary'}
                    icon={<ArrowUturnLeftIcon />}
                    id={`manual-accessories-restore-icon-${index}`}
                    data-testid={`manual-accessories-restore-icon-${index}`}
                    onClick={() => restoreAccessory(index)}
                    disabled={disabled}
                />
            ) : (
                <Button
                    buttonStyle={'tertiary'}
                    id={`manual-accessories-trash-icon-${index}`}
                    data-testid={`manual-accessories-trash-icon-${index}`}
                    icon={<TrashIcon />}
                    onClick={() => removeAccessory(index)}
                    disabled={disabled}
                />
            )}
        </AccessoryActionBaseIconContainer>
    );
};
